import { buttonWithPrefixSuffixTitle } from '../icons';
import { DEFAULT_CSS_CLASS } from '@constants';

const defaultBlockCssClass = DEFAULT_CSS_CLASS.BUTTON;

const prefixTitleAndSuffixTitle = {
  name: 'button-with-prefix title-and-title-and-suffix title',
  title: 'Button with Prefix and Suffix',
  icon: buttonWithPrefixSuffixTitle,
  scope: ['block'],
  attributes: {
    blockClassNames: [
      {
        value: `${defaultBlockCssClass}--primary`,
        label: 'Primary',
      },
    ],
  },
  innerBlocks: [
    [
      'b3rg/span',
      {
        blockClassNames: [
          { value: `${defaultBlockCssClass}__p`, label: 'Prefix' },
        ],
      },
      [
        [
          'core/paragraph',
          {
            content: 'Prefix',
            placeholder: 'Add Prefix Title',
          },
        ],
      ],
    ],
    [
      'core/paragraph',
      {
        className: 'title',
        content: 'Button Text',
        placeholder: 'Add Button Title',
      },
    ],
    [
      'b3rg/span',
      {
        blockClassNames: [
          { value: `${defaultBlockCssClass}__s`, label: 'Suffix' },
        ],
      },
      [
        [
          'core/paragraph',
          {
            content: 'Suffix',
            placeholder: 'Add Suffix Title',
          },
        ],
      ],
    ],
  ],
};

export default prefixTitleAndSuffixTitle;
